<template>
  <div v-show="show" class="span-top">
    <div class="grey-bar">
      选择待抵扣商品(汇总：共{{ sum_num }}件，计{{ sum_price }}元)
    </div>
    <el-table
      :data="list"
      height="400"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" align="center"></el-table-column>
      <el-table-column
        prop="create_time"
        label="开单时间"
        align="center"
      ></el-table-column>
      <el-table-column label="商品图片" align="center">
        <template slot-scope="scope">
          <div v-viewer class="image-box-small">
            <img :src="scope.row.goods_img" class="viewer-img" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="goods_name"
        label="商品名称"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="goods_no"
        label="商品货号"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="goods_kh"
        label="商品款号"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="price"
        label="代采单价"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column label="待抵扣" show-overflow-tooltip align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.num }} / {{ scope.row.sum_price }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="选择使用"
        show-overflow-tooltip
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.choose_num"
            size="small"
            :max="scope.row.num"
            :min="0"
          ></el-input-number>
        </template>
      </el-table-column>
    </el-table>
    <div class="grey-bar">
      <div>
        开单金额：共{{ $parent.calcTotalMap.total_num }}件，计{{
          $parent.calcTotalMap.total_price
        }}元
      </div>
      <div>
        选用抵扣：共{{ calcSeletions.num }}件，计{{ calcSeletions.price }}元
      </div>
    </div>
    <div>
      <el-button type="danger" @click="cancel">取消</el-button>
      <el-button type="primary" @click="comfirm">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      sum_num: [],
      sum_price: [],
      show: false,
      return_list: [],
      selections: [], // 选中的id
      id_map_idx: {}, // 抵扣id在哪行
    };
  },

  computed: {
    calcSeletions() {
      const rs = {
        num: 0,
        price: "0.00",
      };
      this.selections.forEach((unique) => {
        const row = this.list[this.id_map_idx[unique]];
        rs.num += row.choose_num;
        rs.price = this.$parent._bcAdd(rs.price, row.choose_num * row.price);
      });
      return rs;
    },
  },

  methods: {
    calling() {
      this.$parent
        .post(this.$parent.urls.get_ded, {
          supply_id: this.$parent.routeParams.supply_id,
          pgid: this.$parent.routeParams.pgid,
        })
        .then((data) => {
          this._setData(data);
          this.show = true;
        });
    },

    _setData(data) {
      this.sum_price = data.ded.sumPrice;
      this.sum_num = data.ded.sumNum;
      this.list = [];
      this.id_map_idx = {};
      let idx = 0;
      data.ded.list.forEach((row) => {
        // row.choose_num = 0;
        row.detail.forEach((item) => {
          const ls = Object.assign(item, {
            create_time: row.create_time,
            goods_img: row.goods_img,
            goods_name: row.goods_name,
            goods_no: row.goods_no,
            goods_kh: row.goods_kh,
            choose_num: 0,
          });
          this.list.push(ls);
          this.id_map_idx[this.combianUnique(ls)] = idx;
          idx += 1;
        });
      });
      // this.list = data.ded.list;
    },

    handleSelectionChange(selections) {
      this.selections = [];
      selections.forEach((select) => {
        this.selections.push(this.combianUnique(select));
      });
    },

    combianUnique(row) {
      return `${row.id}_${row.reject_id}`;
    },

    cancel() {
      this.show = false;
    },

    comfirm() {
      const actualPrice = this.$parent.settlementAmount(
        this.$parent.calcTotalMap.total_price,
        this.$parent.ded_data.sum_price,
        this.$parent.activity_fee_amount,
        this.$parent.rebateData.total_ded
      );

      // parseFloat(this.$parent.calcTotalMap.total_price) -
      // parseFloat(this.$parent.activity_fee_amount);

      console.log("🚀 : comfirm : actualPrice", actualPrice);
      console.log(
        "🚀 : comfirm : this.calcSeletions.price",
        this.calcSeletions.price
      );
      if (
        parseFloat(this.calcSeletions.price) >
        this.$parent.calcTotalMap.total_price
      ) {
        // this.$message.error(
        //   `抵扣金额(${
        //     this.calcSeletions.price
        //   })大于实际结算金额(${actualPrice.toFixed(2)}), 请重新选择`
        // );
        this.$message.error(
          `抵扣金额(${this.calcSeletions.price})大于实际结算金额(${this.$parent.calcTotalMap.total_price}), 请重新选择`
        );
        return;
      }
      const list = [];
      this.selections.forEach((unique) => {
        const row = this.list[this.id_map_idx[unique]];
        if (row.choose_num == 0) {
          return;
        }
        list.push({
          id: row.id,
          reject_id: row.reject_id,
          num: row.choose_num,
          price: row.price,
        });
      });
      this.$parent.confirmDed(
        list,
        this.calcSeletions.price,
        this.calcSeletions.num
      );
      this.cancel();
      this.$emit("on-confirm");
    },
  },
};
</script>

<style scoped>
.grey-bar {
  /* margin-top:20px */
  background-color: #eee;
}

.span-top {
  margin-top: 15px;
  padding: 5px 10px;
  border-radius: 5px;
}

.image-box-small {
  width: 40px;
  height: 40px;
}

.viewer-img {
  max-width: 100%;
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/purchaseverify/components/DedTable.vue